import { createSlice } from '@reduxjs/toolkit';

// Slice
const slice = createSlice({
  name: 'employee',
  initialState: {
    employee: null,
    employeeOnboarding: null,
    employeeExit: null,
    hmoBeneficiary: null,
    hmoDependants: null
  },
  reducers: {
    setEmployee: (state, { payload }) => {
      state.employee = payload;
    },
    setEmployeeOnboarding: (state, { payload }) => {
      state.employeeOnboarding = payload;
    },
    setEmployeeExit: (state, { payload }) => {
      state.employeeExit = payload;
    },
    setHmoBeneficiary: (state, { payload }) => {
      state.hmoBeneficiary = payload;
    },
    setHmoDependants: (state, { payload }) => {
      state.hmoDependants = payload;
    },
  },
});

// Actions
export const { setEmployee, setEmployeeOnboarding, setEmployeeExit, setHmoBeneficiary, setHmoDependants } = slice.actions;

export default slice.reducer;
